import React from 'react';
import styled from '@emotion/styled';

import { ProductInfoProvidedNoticeContents } from '../components/ProductInfoProvidedNoticeContents';
import { ProductInfoProvidedNoticeTitle } from '../components/ProductInfoProvidedNoticeTitle';
import { useProductInfoProvidedNoticeService } from '../services/useProductInfoProvidedNoticeService';

interface Props {
  open?: boolean;
}

export const ProductInfoProvidedNoticeContainer: React.FC<React.PropsWithChildren<Props>> = ({ open = false }) => {
  const {
    essentials,
    show_essentials,
    is_opened,
    moveToMetaPdp,
    show_product_information,
    handleOpened,
    onClickInquiry,
  } = useProductInfoProvidedNoticeService({ is_opened: open });

  return (
    <Container>
      <ProductInfoProvidedNoticeTitle is_opened={is_opened} onClickToggle={handleOpened} />
      <ProductInfoProvidedNoticeContents
        is_opened={is_opened}
        essentials={essentials}
        show_essentials={show_essentials}
        show_product_information={show_product_information}
        onClickPdpLink={moveToMetaPdp}
        onClickInquiry={onClickInquiry}
      />
    </Container>
  );
};

const Container = styled.div`
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
`;
